import { useHistory, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react'

// components
import { errorSwal, successDeleteSwal } from '../../helper/sweetalert';
import ConfirmDelete from '../../components/ConfirmDelete';
import CustomButton from '../../components/CustomButton'
import { numberFormat } from '../../helper';
import { S3_URL } from '../../const';

// apollo-client
import { LazyLoadImage } from "react-lazy-load-image-component";
import { DELETE_PRODUCT } from '../../apollo/product/Mutation';
import { useMutation } from '@apollo/client';

// icons
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';

// react-bootrap
import { Col, Form, Row, Spinner, Badge } from 'react-bootstrap';

function DetailProduct() {

    const history = useHistory()
    const Location = useLocation()
    const [showDelete, setShowDelete] = useState(false);
    const [Delete, setDelete] = useState("");
    const [isloading, setIsLoadding] = useState(false)

    // ============== > UseLazyQuery And UseMutaion <============== 

    const [deleteProduct, { loading: loadingDelete }] = useMutation(DELETE_PRODUCT)

    // ============== > useEffect <============== 

    useEffect(() => {
        _fectLoadding()
    }, [])

    const _fectLoadding = async () => {
        if (Location) {
            await setIsLoadding(true)
        } else {
            await setIsLoadding(false)
        }
    }

    // ============== > fuctions <============== 

    const handleShowDelete = (id, name) => {
        setDelete({ name, id });
        setShowDelete(true);
    };

    const _confirmeDelete = async () => {
        try {
            if (loadingDelete) return;
            await deleteProduct({
                variables: {
                    where: {
                        id: Delete?.id,
                    },
                },
            });

            successDeleteSwal('ລົບສຳເລັດ')
            setShowDelete(false);
            history.goBack()
        } catch (err) {
            errorSwal("ການລົບຂໍ້ມູນບໍ່ສຳເລັດ !");
        }
    };

    return (
        <React.Fragment>
            <div style={{
                padding: '20px'
            }}>

                <div style={{
                    backgroundColor: "#FFFFFF",
                }}>
                    {/* box head */}

                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: "center",
                        padding: '20px',
                        boxShadow: ' 0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)'

                    }}>
                        <span style={{ fontSize: '28px', color: '#6B7280' }} >
                            <ArrowBackIcon sx={{ fontSize: "30px", cursor: "pointer" }} onClick={() => history.goBack()} />
                            &emsp;ລາຍລະອຽດສິນຄ້າ</span>
                        <span style={{
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}><CustomButton
                                width="149px"
                                height="42px"
                                borderRadius="8px"
                                textalign="center"
                                border="1px solid #19C332"
                                title="ເເກ້ໄຂ"
                                color="#19C332"
                                background="#F7F7F7"
                                icon={<CreateIcon sx={{ color: "#19C332" }} />}
                                onClick={() => history.push('/editproduct', { state: Location.state.state })}
                            />
                            &emsp;
                            <CustomButton
                                width="149px"
                                height="42px"
                                margin="0"
                                title="ລຶບ"
                                border="1px solid #DC2626"
                                borderRadius="8px"
                                background="#F7F7F7"
                                color="#DC2626"
                                icon={<DeleteIcon sx={{ color: '#D21C1C' }} />}
                                onClick={() => handleShowDelete(Location.state.state?.id, Location.state.state?.title)}
                            />
                        </span>
                    </div>

                    {/* end box head */}

                    <div style={{
                        display: 'flex',
                        marginTop: "20px"
                    }}>

                        {/* box image */}

                        <div style={{
                            width: '50%',
                            display: "flex",
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 20
                        }}>
                            <div style={{
                                height: 350,
                                width: 350,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                border: '1px solid #E5E7EB',
                                borderRadius: 8,
                                overflow: 'hidden',
                                backgroundColor: '#F9FAFB'
                            }}>
                                {(!Location?.state?.state?.image || Location.state.state.image.length === 0) ? (
                                    <img style={{ height: '100%', width: '100%', objectFit: 'contain' }} src="https://isjade.simplify.cool/images/no-image-2.jpg" alt="no-image" />
                                ) : (
                                    <LazyLoadImage
                                        src={S3_URL + (Array.isArray(Location.state.state.image) ? Location.state.state.image[0] : Location.state.state.image)}
                                        style={{ objectFit: 'contain' }}
                                        width="100%"
                                        height="100%"
                                        alt="Main product"
                                    />
                                )}
                            </div>
                            
                            {Array.isArray(Location?.state?.state?.image) && Location.state.state.image.length > 1 && (
                                <div style={{ 
                                    display: 'flex', 
                                    gap: 10, 
                                    marginTop: 15, 
                                    flexWrap: 'wrap', 
                                    justifyContent: 'center' 
                                }}>
                                    {Location.state.state.image.map((img, idx) => (
                                        <div key={idx} style={{ 
                                            width: 60, 
                                            height: 60, 
                                            border: idx === 0 ? '2px solid #3C169B' : '1px solid #E5E7EB',
                                            borderRadius: 4,
                                            overflow: 'hidden'
                                        }}>
                                            <img 
                                                src={S3_URL + img} 
                                                alt={`thumb-${idx}`} 
                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                                            />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* end box image */}

                        <div style={{
                            // backgroundColor: 'blue',
                            width: '50%',
                            paddingLeft: '20px',
                            paddingRight: "20px"
                        }}>
                            <Form.Group className="mb-3" controlId="formGroupEmail">
                                <Form.Label>ຊື່ສິ້ນຄ້າ</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={Location?.state?.state?.title}
                                />
                            </Form.Group>

                            <Row>
                                <Col>
                                    <Form.Label>ເລກ ID ສິ້ນຄ້າ</Form.Label>
                                    <Form.Control
                                        value={Location?.state?.state?.barCode}
                                    />
                                </Col>
                                <Col>
                                    <Form.Label>ແບນສິນຄ້າ</Form.Label>
                                    <Form.Control
                                        value={Location?.state?.state?.brand?.name}
                                    />
                                </Col>
                            </Row>

                            <Row className='mt-4'>
                                <Col>
                                    <Form.Label>ປະເພດສິນຄ້າ</Form.Label>
                                    <Form.Control
                                        value={Location?.state?.state?.category?.name}
                                    />
                                </Col>
                                <Col>
                                    <Form.Label>ຈຳນວນສິນຄ້າ</Form.Label>
                                    <Form.Control
                                        value={Location?.state.state?.amount}
                                    />
                                </Col>
                                <Col>
                                    <Form.Label>ຫົວໜ່ວຍ</Form.Label>
                                    <Form.Control
                                        value={Location?.state?.state?.unit?.name}
                                    />
                                </Col>
                            </Row>

                            <Row className='mt-3'>
                                <Col>
                                    <Form.Label>ລາຄາຊື้ສິ້ນຄ້າ</Form.Label>
                                    <Form.Control
                                        value={Location?.state?.state?.price}
                                    />
                                </Col>
                                <Col>
                                    <Form.Label>ລາຄາໂປຣໂມຊັ່ນ {Location?.state?.state?.isPromo && <Badge bg="success">ເປີດໃຊ້</Badge>}</Form.Label>
                                    <Form.Control
                                        value={Location?.state?.state?.promoPrice}
                                    />
                                </Col>
                                <Col>
                                    <Form.Label>ສະກຸນເງີນ</Form.Label>
                                    <Form.Control
                                        value={Location?.state?.state?.currency}
                                    />
                                </Col>
                            </Row>

                            <Row className='mt-3'>
                                <Col>
                                    <Form.Label>ລາຄາຂາຍສິນຄ້າ 1</Form.Label>
                                    <Form.Control
                                        value={numberFormat(Location?.state?.state?.priceOptions[0])}
                                    />
                                </Col>
                                <Col>
                                    <Form.Label>ລາຄາຂາຍສິນຄ້າ 2</Form.Label>
                                    <Form.Control
                                        value={numberFormat(Location?.state?.state?.priceOptions[1])}
                                        placeholder="First name" />
                                </Col>
                                <Col>
                                    <Form.Label>ລາຄາຂາຍສິນຄ້າ 3</Form.Label>
                                    <Form.Control
                                        value={numberFormat(Location?.state?.state?.priceOptions[2])}
                                        placeholder="First name" />
                                </Col>

                            </Row>

                        </div>

                    </div>

                    <div style={{
                        marginLeft: "20px",
                        marginRight: "20px"
                    }}>
                        <Form.Label>ລາຍລະອຽດເພີ່ມເຕີມ</Form.Label>
                        <Form.Control
                            as="textarea"
                            placeholder="ກະລຸນນາປ້ອນຊື່ສິນຄ້າ..."
                            value={Location?.state?.state?.detail}
                            style={{ height: '100px' }}
                        />
                    </div>
                </div>

            </div>

            {/* end delete modal */}

            <ConfirmDelete
                title={loadingDelete ? <Spinner /> : "ລົບ"}
                open={showDelete}
                text={Delete?.name}
                onClose={() => setShowDelete(false)}
                onSubmit={_confirmeDelete}
            />


        </React.Fragment >
    )
}

export default DetailProduct